import { ButtonUtils, ObjectBuilder, MeshUtils, Rectangle3D, ScrollViewer3D, WrapPanel } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { text } from "../../TextResources";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { LayoutComponentHelper } from "./LayoutComponentHelper";
import { BroadcastManagerState } from "@dreamcam/web-sdk";
import { StringUtils } from "../utils/StringUtils";
import { DateUtils } from "../../utils/Time";
export class VideoClipInfoPanel {
    constructor(mesh2d, callbacks) {
        this._currentState = BroadcastManagerState.UNINITIALIZED;
        this._mesh2d = mesh2d;
        this._callbacks = callbacks;
        const menu = Env.videoClip.menu;
        const inf = menu.infoPanel;
        const backgroundPanel = new Rectangle3D("videoClipInfoPanelContainer");
        backgroundPanel.cornerRadius = this._mesh2d.m2px(menu.cornerRadius);
        backgroundPanel.background = menu.background;
        backgroundPanel.thickness = 0;
        this._mesh2d.texture.addControl(backgroundPanel);
        const headerContainer = new Container("videoClipInfoPanelHeaderContainer");
        headerContainer.heightInPixels = this._mesh2d.m2px(inf.header.height);
        headerContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        headerContainer.background = inf.header.background;
        backgroundPanel.addControl(headerContainer);
        const caption = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipInfoPanelHeaderCaption", text.videoClip_menu_info_caption, inf.header.caption);
        headerContainer.addControl(caption);
        const closeButton = ButtonUtils.CreateImgButton("videoClipInfoPanelCloseButton", inf.header.closeButtonLayout, this._mesh2d);
        closeButton.onClickObserver.add(() => setTimeout(() => {
            this.hide();
            callbacks.onClose();
        }, 0));
        closeButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        headerContainer.addControl(closeButton);
        this._scrollViewer = new ScrollViewer3D("videoClipInfoPanelScrollViewer");
        this._scrollViewer.widthInPixels = this._mesh2d.m2px(inf.width);
        this._scrollViewer.heightInPixels = this._mesh2d.m2px(inf.height - inf.header.height);
        this._scrollViewer.topInPixels = this._mesh2d.m2px(inf.header.height);
        this._scrollViewer.color = inf.scrollViewer.colors.background;
        this._scrollViewer.barColor = inf.scrollViewer.colors.bar;
        this._scrollViewer.hoverBarColor = inf.scrollViewer.colors.hoverBar;
        this._scrollViewer.pressedBarColor = inf.scrollViewer.colors.pressedBar;
        this._scrollViewer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this._scrollViewer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._scrollViewer.verticalBarPaddingInPixels = {
            left: this._mesh2d.m2px(inf.scrollViewer.verticalBar.padding.left),
            right: this._mesh2d.m2px(inf.scrollViewer.verticalBar.padding.right),
            top: this._mesh2d.m2px(inf.scrollViewer.verticalBar.padding.top),
            bottom: this._mesh2d.m2px(inf.scrollViewer.verticalBar.padding.bottom)
        };
        this._scrollViewer.barSizeInPixels = this._mesh2d.m2px(inf.scrollViewer.verticalBar.size);
        this._scrollViewer.autoSizeThumbs = true;
        this._scrollViewer.verticalValue = 0;
        // let prevScrollViewerValue = 0;
        // scrollViewer.onVerticalValueChangedObservable.add(async (v) => {
        //     if (v > prevScrollViewerValue && v >= this._scrollDownThreshold && this._displayedPosts.last !== this._lastRequestedPostsOffset)
        //     {
        //         this._scrollDirection = "down";
        //         this._lastRequestedPostsOffset = this._displayedPosts.last;
        //         await this._menuFunctions.getModelPostsAsync(this._postLimit, this._displayedPosts.last);
        //     }
        //     else if (v < prevScrollViewerValue && v <= this._scrollUpThreshold && this._displayedPosts.first !== 0 && Math.max(this._displayedPosts.first - this._postLimit, 0) !== this._lastRequestedPostsOffset)
        //     {
        //         this._scrollDirection = "up";
        //         const firstPost = Math.max(this._displayedPosts.first - this._postLimit, 0);
        //         this._lastRequestedPostsOffset = firstPost;
        //         await this._menuFunctions.getModelPostsAsync(Math.min(this._postLimit, firstPost), firstPost);
        //     }
        //     prevScrollViewerValue = v;
        // });
        backgroundPanel.addControl(this._scrollViewer);
        const stackPanel = new StackPanel("videoClipInfoPanelStackPanel");
        stackPanel.isVertical = true;
        this._scrollViewer.addControl(stackPanel);
        const gaps = inf.scrollViewer.gaps;
        const createGap = (height) => {
            const gap = new Container("videoClipInfoPanelStackPanelGap");
            gap.widthInPixels = 1;
            gap.heightInPixels = this._mesh2d.m2px(height);
            return gap;
        };
        const createSeparator = () => {
            const separator = new Container("videoClipInfoPanelSeparator1");
            separator.widthInPixels = this._mesh2d.m2px(inf.scrollViewer.separator.width);
            separator.heightInPixels = this._mesh2d.m2px(inf.scrollViewer.separator.height);
            separator.background = inf.scrollViewer.separator.background;
            return separator;
        };
        stackPanel.addControl(createGap(gaps.height24));
        // Model block:
        {
            const mp = inf.scrollViewer.modelProfileContainer;
            const openBroadcastButton = ButtonUtils.CreateImgButton("videoClipInfoPanelBroadcastPanel", mp.colorLayout, this._mesh2d);
            openBroadcastButton.onClickObserver.add(() => {
                setTimeout(async () => {
                    if (this._modelName.text) {
                        await callbacks.openBroadcastByModelNicknameAsync(this._modelName.text);
                    }
                }, 0);
            });
            stackPanel.addControl(openBroadcastButton);
            const avatarControls = LayoutComponentHelper.createModelProfileControl(this._mesh2d, openBroadcastButton, mp.avatar);
            avatarControls.rootContainer.horizontalAlignment = Container.HORIZONTAL_ALIGNMENT_LEFT;
            avatarControls.rootContainer.widthInPixels = this._mesh2d.m2px(mp.avatar.photo.outlineDiameter);
            avatarControls.rootContainer.leftInPixels = this._mesh2d.m2px(mp.avatar.photo.left);
            this._outlineContainer = avatarControls.outlineContainer;
            this._avatar = avatarControls.modelProfileImage;
            this._modelName = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipInfoPanelModelName", "", mp.modelNickname);
            openBroadcastButton.addControl(this._modelName);
            this._watchShowText = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipInfoPanelWatchShowText", text.videoClip_menu_main_live_show, mp.watchShowText);
            openBroadcastButton.addControl(this._watchShowText);
        }
        stackPanel.addControl(createGap(gaps.height24));
        stackPanel.addControl(createSeparator());
        // Video clip description block:
        {
            this._descriptionTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipInfoPanelVideoClipDescription", "", inf.scrollViewer.videoClipDescription);
            stackPanel.addControl(this._descriptionTextBlock);
            this._addedTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipInfoPanelVideoClipAdded", "", inf.scrollViewer.videoClipAdded);
            stackPanel.addControl(this._addedTextBlock);
        }
        stackPanel.addControl(createSeparator());
        // Video clip tags block:
        {
            const tagsCaptionTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipInfoPanelVideoClipTagsCaption", text.lobby_video_tags_header, inf.scrollViewer.videoClipTagsCaption);
            stackPanel.addControl(tagsCaptionTextBlock);
            this._tagsPanel = new WrapPanel("videoClipInfoPanelTags");
            this._tagsPanel.isVertical = true;
            this._tagsPanel.widthInPixels = this._mesh2d.m2px(inf.scrollViewer.tags.width);
            stackPanel.addControl(this._tagsPanel);
        }
        stackPanel.addControl(createGap(gaps.height24));
    }
    get isVisible() {
        return this._mesh2d.mesh.isVisible;
    }
    show() {
        this._callbacks.onShow();
        MeshUtils.show(this._mesh2d);
    }
    hide() {
        if (MeshUtils.isHidden(this._mesh2d))
            return;
        MeshUtils.hide(this._mesh2d);
    }
    stateChanged(state, _isGuest, _reason) {
        if (state === this._currentState)
            return;
        this._currentState = state;
        const statusData = VideoClipInfoPanel._statusMap[state];
        if (!statusData)
            return;
        this._outlineContainer.color = statusData.color;
        const isOffline = state === BroadcastManagerState.OFFLINE;
        this._watchShowText.text = isOffline ? text.videoClip_menu_main_offline_show : text.videoClip_menu_main_live_show;
    }
    outputVideoClip(videoClip) {
        this._modelName.text = videoClip?.modelNickname ?? "";
        this._descriptionTextBlock.text = videoClip?.title ?? "";
        this._addedTextBlock.text = videoClip ? StringUtils.stringFormat(text.videoClip_menu_info_published_at, DateUtils.dateToString(videoClip.publishedAt)) : "";
        this._tagsPanel.clearControls();
        if (videoClip) {
            videoClip.tags.forEach(tag => {
                this._tagsPanel.addControl(LayoutComponentHelper.createUnselectedTagContainer(this._mesh2d, tag, false, Env.videoClip.menu.infoPanel.scrollViewer.tags.unselectedTagsPanel));
            });
        }
        this._scrollViewer.valueToScrollTo = 0;
    }
    outputModelProfile(profile, _filter, _hasVideoClips) {
        this._avatar.setSource(profile.photoUrl, Env.lobby.gallery.defaultPreview.path);
    }
}
VideoClipInfoPanel._statusImage = Env.broadcast.menu.modelProfile.status;
VideoClipInfoPanel._statusMap = {
    [BroadcastManagerState.AWAY]: { color: VideoClipInfoPanel._statusImage.background.away, text: text.lobby_gallery_item_status_away },
    [BroadcastManagerState.PRIVATE_SHOW]: { color: VideoClipInfoPanel._statusImage.background.private, text: text.lobby_gallery_item_status_privateShow },
    [BroadcastManagerState.MY_PRIVATE_SHOW]: { color: VideoClipInfoPanel._statusImage.background.private, text: text.lobby_gallery_item_status_privateShow },
    [BroadcastManagerState.SPY_SHOW]: { color: VideoClipInfoPanel._statusImage.background.private, text: text.lobby_gallery_item_status_privateShow },
    [BroadcastManagerState.PUBLIC]: { color: VideoClipInfoPanel._statusImage.background.live, text: text.lobby_gallery_item_status_live },
    [BroadcastManagerState.OFFLINE]: { color: VideoClipInfoPanel._statusImage.background.offline, text: text.lobby_gallery_item_status_offline },
};
